import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  selectedSurvey: [],
  vehicleListUpdate: [],
  selectedVehicle: [],
  selectedPart: [],
  partListUpdate: [],
  vinData: [],
  vinLoader:false
};

export const surveyPageData = createSlice({
  name: "surveyPageData",
  initialState: INIT_STATE,
  reducers: {
    addItemInSelectedSurvey: (state, action) => {
      state.selectedSurvey = action.payload;
    },
    addItemInVehicleListUpdate: (state, action) => {
      state.vehicleListUpdate = action.payload;
    },
    addItemInSelectedVehicle: (state, action) => {
      state.selectedVehicle = action.payload;
    },
    deleteItemsFromSelectedVehicle: (state) => {
      state.selectedVehicle = {};
    },
    addItemInSelectedPart: (state, action) => {
      state.selectedPart = action.payload;
    },
    deleteItemsFromSelectedPart: (state) => {
      state.selectedPart = {};
    },
    addItemInPartListUpdate: (state, action) => {
      state.partListUpdate = action.payload;
    },
    addItemVin: (state, action) => {
      state.vinData = action.payload;
    },
    setVinValidationLoader: (state, action) => {
      state.vinLoader = action.payload;
    },
  },
});

export const {
  addItemInSelectedSurvey,
  setVinValidationLoader,
  addItemInVehicleListUpdate,
  addItemInSelectedVehicle,
  deleteItemsFromSelectedVehicle,
  addItemInSelectedPart,
  deleteItemsFromSelectedPart,
  addItemInPartListUpdate,
  addItemVin,
} = surveyPageData.actions;

export default surveyPageData.reducer;
